<template>
  <div class="row userStatement">
    <div class="col">
      <div class="Title">訂餐備註</div>
      <textarea class="form-control" placeholder="請記得提醒店家，您對餐點的相關需求，上限 32 字。" v-model="this.$parent.Statement" :disabled="this.$parent.$data.orderHandler == 0"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserStatement"
}
</script>

<style lang="scss" scoped>
.userStatement {
  margin: 20px auto 20px auto !important;
  > .col {
    > .Title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 900;
      color: #87CEFAAA;
      text-shadow: 1px 1px 0 #000000;
    }
    > textarea {
      resize: none;
    }
  }
}
</style>